import { CompetitorRelationListResponse } from "@/api/types/main/schemas";
import { AddCompetitor } from "@/components/custom-ui/add.competitor";
import TableColumnVisibility from "@/components/custom-ui/tables/table.column.visibility";
import { TanstackTable } from "@/components/custom-ui/tables/tanstack.table";
import {
  MemoizedTanstackTableBody,
  TanstackTableBody,
} from "@/components/custom-ui/tables/tanstack.table.body";
import { TanstackTableControlPanel } from "@/components/custom-ui/tables/tanstack.table.control.panel";
import {
  MemoizedTanstackTableHeader,
  TanstackTableHeader,
} from "@/components/custom-ui/tables/tanstack.table.header";
import { DndSortableHeadersContext } from "@/components/tables/dnd.sortable.headers.context";
import { Input } from "@/components/ui/input";
import { TableInstanceHook } from "@/hooks/expanded.table.instance.hook";
import { useGetCompetitorProductColumns } from "@/pages/shared/services/competitors/product/useGetCompetitorProductColumns";
import { TableIds } from "@/store/tables";

export function CompetitorsProductTable({
  tableData,
  date,
  productSKU,
}: {
  tableData: CompetitorRelationListResponse[];
  date: string;
  productSKU: number;
}) {
  const columns = useGetCompetitorProductColumns(date);
  const { table, columnSizeVars, columnOrder } = TableInstanceHook({
    data: tableData,
    columns,
    tableId: TableIds.Services_Competitors_Product,
  });

  return (
    <>
      <TanstackTableControlPanel className="py-1 basis-[20px] flex items-center justify-between ">
        <Input
          placeholder="Введите название товара"
          value={table.getColumn("name")?.getFilterValue() as string}
          onChange={(event) => table.getColumn("name")?.setFilterValue(event.target.value)}
          className=" w-60 2xl:w-80 text-xs 2xl:text-sm h-8 2xl:h-12"
        />
        <div className="flex gap-x-2">
          <TableColumnVisibility table={table} />
          <AddCompetitor productSku={productSKU} date={date} />
        </div>
      </TanstackTableControlPanel>

      <div className="h-[600px]">
        <TanstackTable
          style={{ width: table.getTotalSize(), ...columnSizeVars }}
          className="flex-1"
        >
          {table.getState().columnSizingInfo.isResizingColumn ? (
            <>
              <MemoizedTanstackTableHeader table={table} columnOrder={columnOrder} sticky="true" />
              <MemoizedTanstackTableBody table={table} columnOrder={columnOrder} />
            </>
          ) : (
            <>
              <DndSortableHeadersContext
                table={table}
                tableId={TableIds.Services_Competitors_Product}
              >
                <TanstackTableHeader table={table} columnOrder={columnOrder} sticky="true" />
                <TanstackTableBody table={table} columnOrder={columnOrder} />
              </DndSortableHeadersContext>
            </>
          )}
        </TanstackTable>
      </div>
    </>
  );
}
